// extracted by mini-css-extract-plugin
module.exports = {"title":"_1CHfzP mz-caption","icon":"_3JMzy6 mz-caption"};